import React, { useState, useEffect } from "react";
import BasicInformation from "../../profile/profile-tabs/BasicInformation";
import Password from "../../profile/profile-tabs/Password";
import MainButton from "../../button/MainButton";
import { ADMIN_PROFILE_TABS as adminProfileTabs } from "../../../utilities/defaults/adminProfile/AdminProfileTabs";
import { useGlobalInfo } from "../../../contexts/GlobalInfoContext";
import { useSearchParams } from "react-router-dom";

const AdminProfile: React.FC = () => {
  const { userInfo } = useGlobalInfo();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeAdminProfileTabs, setActiveAdminProfileTabs] = useState(0);

  const isSetPassword = userInfo?.set_password === true;

  useEffect(() => {
    const tab = searchParams.get("tab");
    if (tab === "password") {
      setActiveAdminProfileTabs(1);

      setSearchParams({});
    }
  }, [searchParams]);

  const handleAdminProfileTabsClick = (index: number) => {
    setActiveAdminProfileTabs(index);
  };

  const renderAdminProfileTab = () => {
    switch (activeAdminProfileTabs) {
      case 0:
        return <BasicInformation />;
      case 1:
        return <Password />;
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col w-full overflow-hidden border divide-y divide-gorgonzola-blue-50 rounded-xl border-gorgonzola-blue-50">
      <div className="w-full p-4 md:p-6">
        <h2 className="font-bold text-closed-shutter-300">My Admin Profile</h2>
      </div>

      <div className="p-4 md:p-6">
        <div className="flex flex-col gap-13">
          <div className="flex gap-6 *:min-w-fit overflow-x-auto">
            {adminProfileTabs.map((adminProfileTab, index) => {
              const tabTitle = adminProfileTab.title === "Change Password" && isSetPassword ? "Set Password" : adminProfileTab.title;
              return (
                <MainButton key={index} type={index === activeAdminProfileTabs ? "primary" : "secondary"} onClick={() => handleAdminProfileTabsClick(index)}>
                  {tabTitle}
                </MainButton>
              );
            })}
          </div>
          {renderAdminProfileTab()}
        </div>
      </div>
    </div>
  );
};

export default AdminProfile;
